exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__PanelCards__cards__SqP1l {\n  height: calc(100% - 60px);\n  overflow-x: visible;\n}\n\n.dmb-web__PanelCards__container__zOdRD {\n  height: 100%;\n  overflow-y: scroll;\n}\n\n.dmb-web__PanelCards__cardsSplitCollapsed__Fgcgn {\n  height: auto;\n  overflow-y: hidden;\n}\n\n.dmb-web__PanelCards__cardsSplitExpanded__oOQ9A {\n  height: calc(100% - 50px);\n  overflow-y: auto;\n}\n", ""]);

// exports
exports.locals = {
	"cards": "dmb-web__PanelCards__cards__SqP1l",
	"container": "dmb-web__PanelCards__container__zOdRD",
	"cardsSplitCollapsed": "dmb-web__PanelCards__cardsSplitCollapsed__Fgcgn",
	"cardsSplitExpanded": "dmb-web__PanelCards__cardsSplitExpanded__oOQ9A"
};